<template>
  <div class="game-page">
    <header class="game-page-header">
      <button
        type="button"
        class="game-page-back"
        @click="goBack"
        :aria-label="$store.state.language === 'en' ? 'Go back' : 'နောက်သို့'"
      >
        <i class="fas fa-chevron-left" aria-hidden="true"></i>
      </button>
      <div class="game-page-heading">
        <h1 class="game-page-title">{{ displayProviderName }}</h1>
        <p class="game-page-meta">
          {{ displayGames.length }}
          {{ $store.state.language === 'en' ? 'games' : 'ဂိမ်း' }}
        </p>
      </div>
      <div class="game-page-search-field">
        <i class="fas fa-search game-page-search-icon" aria-hidden="true"></i>
        <input
          v-model="name"
          type="search"
          enterkeyhint="search"
          autocomplete="off"
          class="game-page-search"
          :placeholder="$t('home.search_game')"
        />
      </div>
    </header>

    <section class="game-page-body">
      <div v-if="showEmpty" class="game-page-empty">
        <i class="fas fa-gamepad" aria-hidden="true"></i>
        <template v-if="$store.state.language === 'en'">
          No games match your search. Try another name.
        </template>
        <template v-else>
          ရှာဖွေမှုနှင့် ကိုက်ညီသော ဂိမ်းမရှိပါ။ အခြားစာသားဖြင့် စမ်းကြည့်ပါ။
        </template>
      </div>

      <div v-else class="game-page-grid">
        <button
          v-for="(game, index) in displayGames"
          :key="game.gameID + '-' + index"
          type="button"
          class="game-page-card"
          @click="gameInit(game)"
        >
          <div class="game-page-card__thumb">
            <img
              :src="imageLinkGenerate(game.gameID)"
              :alt="game.gameName"
              loading="lazy"
            />
          </div>
          <span class="game-page-card__name">{{ game.gameName }}</span>
        </button>
      </div>
    </section>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      games: [],
      rows: 0,
      provider: 'Pragmatic',
      name: null,
      newGames: [],
      isMobile: false,
      option1: [
        { text: 'Pragmatic Play', value: 'Pragmatic' },
        { text: 'Jili', value: 'Jili' },
        { text: 'Play Star', value: 'Playstar' },
        { text: 'Fast Spin', value: 'Fastspin' },
        { text: 'Spade Gaming', value: 'Spade' },
      ],
    };
  },
  computed: {
    displayProviderName() {
      const p = this.$route.query.provider || this.provider;
      if (p === 'Pragmatic') return 'Pragmatic Play';
      return p || 'Games';
    },
    displayGames() {
      return this.newGames.length > 0 ? this.newGames : this.games;
    },
    showEmpty() {
      return this.displayGames.length === 0;
    },
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push('/home');
      }
    },
    ...mapActions(['fetchUser']),
    imageLinkGenerate(gameId) {
      if (this.$route.query.provider === 'Jili') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${gameId}.webp`;
      }
      if (this.$route.query.provider === 'Spade') {
        return `https://merchantapi.silverkirin88.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (this.$route.query.provider === 'Fastspin') {
        return `http://api-egame-staging.fsuat.com/thumbnail/en_US/${gameId}.jpg`;
      }
      if (this.$route.query.provider === 'Playstar') {
        return `/build/assets/img/playstar/${gameId}.png`;
      }
      if (this.$route.query.provider === 'FaChai') {
        return `https://agent-icon.fcg1688.net/icon/${gameId}_200x200_en.png`;
      }
      if (this.$route.query.provider === 'PGSoft') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${gameId}.webp`;
      }
      if (this.$route.query.provider === 'JOKER') {
        return `https://img.qiangmingbao.net/gameimages/landscape/${gameId}.png`;
      }
      if (this.$route.query.provider === '5G') {
        return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/5g/${gameId}.png`;
      }
      if (this.$route.query.provider === 'KA') {
        return `https://cdn.myanmarshankoeme.com/build/assets/img/bf688/ka/${gameId}.webp`;
      }
      if (this.$route.query.provider === 'AceWin') {
        return `https://yy24gld.sgp1.cdn.digitaloceanspaces.com/acewin/${gameId}.png`;
      }
      if (this.$route.query.provider === 'JDB') {
        return `https://dlntdk2it99.anhuidingyue.com/jdb-assetsv3/games/${gameId}/${gameId}_en.png`;
      }

      return `https://cdn.myanmarshankoeme.com/build/assets/img/fgg/${gameId}.webp`;
    },
    async fetchGames() {
      try {
        const res = await axios.get('/games', {
          params: {
            provider: this.$route.query.provider,
          },
        });

        this.games = res.data.data;
        this.games = this.games.filter((game) => game.gameTypeID.includes('ac'));
      } catch (error) {
        console.log(error);
      }
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: this.$route.query.provider,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        let gameUrl = res.data?.data?.gameUrl;
        if (!gameUrl) {
          this.$store.commit('setLoading', false);
          return;
        }

        // PGSoft (and some providers) return HTML instead of a URL
        const raw = String(gameUrl).trim();
        if (raw.startsWith('<')) {
          const blob = new Blob([raw], { type: 'text/html;charset=utf-8' });
          gameUrl = URL.createObjectURL(blob);
        }

        this.$store.commit('setIframeURL', gameUrl);
        this.$router.push('/iframeURL');

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
      }
    },
    isPWA() {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true ||
        document.referrer.startsWith('android-app://')
      );
    },
  },
  watch: {
    provider() {
      this.fetchGames();
    },
    name() {
      const q = (this.name || '').toLowerCase().trim();
      if (!q) {
        this.newGames = [];
        return;
      }
      this.newGames = this.games.filter((game) => game.gameName.toLowerCase().includes(q));
    },
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    if (window.innerWidth < 768) {
      this.isMobile = true;
    }
    await this.fetchGames();
    this.$store.commit('setLoading', false);
  },
};
</script>
<style scoped>
</style>
